export default __webpack_public_path__ + "static/media/coverPrimary.7d206283.jpg";